import { render, staticRenderFns } from "./addOrEditApartmentModal.vue?vue&type=template&id=80dbba42&"
import script from "./addOrEditApartmentModal.vue?vue&type=script&lang=js&"
export * from "./addOrEditApartmentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports